import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  ModalContentProps,
  ModalBodyProps,
} from '@chakra-ui/react';

interface FullScreenModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  modalContentProps?: ModalContentProps;
  modalBodyProps?: ModalBodyProps;
  contentWrapperStyle?: React.CSSProperties;
}

export const FullScreenModal: React.FC<FullScreenModalProps> = ({
  isOpen,
  onClose,
  children,
  modalContentProps = {},
  modalBodyProps = {},
  contentWrapperStyle = {},
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      motionPreset="slideInBottom"
      closeOnOverlayClick={false}
      closeOnEsc={true}
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        mx="1vw"
        my="2vh"
        width="99vw"
        height="98vh"
        borderRadius="sm"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        position="relative"
        {...modalContentProps}
      >
        <ModalCloseButton
          size="lg"
          position="absolute"
          top="4px"
          right="4px"
          zIndex={100}
          bg="transparent"
          _hover={{
            bg: '#F6F7F7',
          }}
        />
        <ModalBody
          p="34px 39px"
          flex="1"
          overflow="hidden"
          display="flex"
          position="relative"
          {...modalBodyProps}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              ...contentWrapperStyle,
            }}
          >
            {children}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
